import React, { memo } from 'react';
export const ProductIntroSection = () => {
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-151" data-mp="1yfisanzlq8io">
      <div className="max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-152" data-mp="28ltyhut19hz2">
        <div className="inline-block bg-familia-cyan text-familia-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-153" data-mp="2nbj6o9zjmm8u">
          🔑 Stop Searching. Start Using.
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold mb-6" data-id="element-154" data-mp="1un41ef67riap">
          One simple system. <br className="hidden md:block" data-id="element-155" data-mp="1ppbzcsbuufss" />
          <span className="text-familia-cyan" data-id="element-156" data-mp="24ki99qe2myre">
            A more intentional daily routine.
          </span>
        </h2>

        <p className="text-familia-gray text-[16px] md:text-xl max-w-3xl mx-auto leading-relaxed" data-id="element-157" data-mp="1zkng1g6tpx36">
          Instead of piecing together exercises, cognitive activities, care
          notes and ideas from different places, Vitality 360™ gives you a clear
          collection of ready-to-use resources designed for everyday life at
          home. Everything is already organized in one place, so you can choose
          an activity and get started in minutes.
        </p>
      </div>
    </section>;
};